import React from 'react';
import { slide as Menu } from 'react-burger-menu';
import { Menu as AntdMenu } from 'antd';
import './Sidebar.css';
import 'bootstrap/dist/css/bootstrap.css';
import Dropdown from 'react-bootstrap/Dropdown';
import {ButtonGroup} from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { useCookies } from 'react-cookie';
import { useState ,useEffect } from "react";
import {Button} from "reactstrap";
import { performLogout } from './services/LoginServices';
import {
  AUTH_COOKIE_KEYS,
  getPermissionList,
  invalidateAuthSession,
  isAuthSessionValid,
  isSuperuser,
  persistAuthProfile,
  hasResolvedAuthProfile,
} from './utils/authSession';
import { getSessionProfile } from './services/LoginServices';

export default function Sidebar({ pageWrapId = 'page-wrap', outerContainerId = 'outer-container' }) {
  let navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies(AUTH_COOKIE_KEYS);
  const [name] = useCookies(['myName']);
  const [category] = useCookies(['myCategory']);
  const [superuser] = useCookies(['mySuperuser']);
  const [menuReady, setMenuReady] = useState(false);
  const [authProfile, setAuthProfile] = useState(() => ({
    isAdmin: isSuperuser(superuser),
    permissions: getPermissionList(category),
  }));
  const { isAdmin, permissions } = authProfile;
  const can = (permission) => isAdmin || permissions.includes(permission);
  const canAny = (...permissionList) => (
    isAdmin || permissionList.some((permission) => permissions.includes(permission))
  );
  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await performLogout(cookies);
    } catch (error) {
      console.warn('Logout request failed:', error?.message || error);
    } finally {
      invalidateAuthSession(removeCookie);
      navigate('/', { replace: true });
    }
  };
  useEffect(() => {
    if (!isAuthSessionValid(cookies.myToken)) {
      invalidateAuthSession(removeCookie);
      navigate('/', { replace: true });
    }
  }, [cookies.myToken, navigate, removeCookie]);

  useEffect(() => {
    setAuthProfile({
      isAdmin: isSuperuser(superuser),
      permissions: getPermissionList(category),
    });
  }, [category, superuser]);

  useEffect(() => {
    let cancelled = false;

    const hydrateAuthProfile = async () => {
      if (!cookies.myToken || hasResolvedAuthProfile(category, superuser)) {
        return;
      }
      try {
        const profile = await getSessionProfile(cookies);
        if (cancelled || !profile) {
          return;
        }
        persistAuthProfile(profile, setCookie, removeCookie);
        setAuthProfile({
          isAdmin: Boolean(profile.is_superuser),
          permissions: getPermissionList({ myCategory: profile.category }),
        });
      } catch (error) {
        console.warn('Unable to restore sidebar permissions:', error?.message || error);
      }
    };

    hydrateAuthProfile();

    return () => {
      cancelled = true;
    };
  }, [cookies.myToken, category, superuser, setCookie, removeCookie]);

  useEffect(() => {
    let cancelled = false;
    let attempts = 0;

    const ensureMenuTargets = () => {
      if (cancelled) {
        return;
      }
      const hasTargets = (
        document.getElementById(pageWrapId)
        && document.getElementById(outerContainerId)
      );
      if (hasTargets || attempts > 20) {
        setMenuReady(true);
        return;
      }
      attempts += 1;
      window.requestAnimationFrame(ensureMenuTargets);
    };

    ensureMenuTargets();

    return () => {
      cancelled = true;
    };
  }, [pageWrapId, outerContainerId]);

  if (!menuReady) {
    return null;
  }

  return (
    
    <Menu
      pageWrapId={pageWrapId}
      outerContainerId={outerContainerId}
      width={280}
      noOverlay={false}
      disableOverlayClick={false}
    >
      <div style={{marginLeft:"60px"}}>
          <Dropdown drop='down-centered'>
            <Dropdown.Toggle variant="primary" id="dropdown-basic">
            <i className="fa fa-user-circle fa-lg"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.ItemText><span style={{color:"cornflowerblue"}}>{name['myName']}</span></Dropdown.ItemText>
              <Dropdown.Item onClick={handleLogout}>Log Out</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
      </div>
      
      <AntdMenu theme="dark" mode="inline" className="sidebar-nav-menu" style={{ width: 250, backgroundColor: "rgb(2, 2, 49)" }} >
        {can('is_rmc_admin') && (
          <AntdMenu.SubMenu key="admin" title='ADMIN'>
            <AntdMenu.Item key="company"  onClick={() =>{navigate("/Company")}}>
               Company 
            </AntdMenu.Item>
            <AntdMenu.Item  key="plant" onClick={() =>{navigate("/Plant")}}>
              Plant
            </AntdMenu.Item>
            <AntdMenu.Item  key="plant_configuration" onClick={() =>{navigate("/PlantConfiguration")}}>
              Plant Configuration
            </AntdMenu.Item>
            <AntdMenu.Item  key="number_setting" onClick={() =>{navigate("/NumberSetting")}}>
              Number Setting
            </AntdMenu.Item>
            <AntdMenu.Item  key="approval_setting" onClick={() =>{navigate("/ApprovalSetting")}}>
              Approval Setting
            </AntdMenu.Item>
            <AntdMenu.Item  key="unit" onClick={() =>{navigate("/Unit")}}>
              Unit
            </AntdMenu.Item>
            <AntdMenu.Item  key="tax" onClick={() =>{navigate("/Tax")}}>
              Tax
            </AntdMenu.Item>
            <AntdMenu.Item key="product"  onClick={() =>{navigate("/Product")}}>
              Product
            </AntdMenu.Item>
            <AntdMenu.Item  key="sales_representative" onClick={() =>{navigate("/SalesRep")}}>
              Sales Representative
            </AntdMenu.Item>
            <AntdMenu.Item  key="gang" onClick={() =>{navigate("/Gang")}}>
              Gang
            </AntdMenu.Item>
            {isAdmin && (
              <AntdMenu.Item  key="permission" onClick={() =>{navigate("/Permission")}}>
                Permission
              </AntdMenu.Item>
            )}
            {isAdmin && (
              <AntdMenu.Item key="ip_address"  onClick={() =>{navigate("/IpAddress")}}>
                IP Address
              </AntdMenu.Item>
            )}
            {isAdmin && (
              <AntdMenu.Item key="user"  onClick={() =>{navigate("/User")}}>
                User
              </AntdMenu.Item>
            )}
          </AntdMenu.SubMenu>
        )}
        
        {can('is_marketting') && (
          <AntdMenu.SubMenu key="marketting" title='MARKETTING'>
            {canAny('add_entity_customer_detail', 'view_entity_customer_detail', 'change_entity_customer_detail', 'delete_entity_customer_detail') && (
              <AntdMenu.Item key="customer" onClick={() =>{navigate("/CustomerMain")}}>
                Billing Registration
              </AntdMenu.Item>
            )}
            {canAny('add_quotation', 'view_quotation', 'edit_quotation', 'delete_quotation') && (
              <AntdMenu.Item key="quotation"  onClick={() =>{navigate("/Quotation")}}>
                Quotation
              </AntdMenu.Item>
            )}
            {canAny('add_sales_order_master', 'view_sales_order_master', 'change_sales_order_master', 'delete_sales_order_master') && (
              <AntdMenu.Item key="sales_order" onClick={() =>{navigate("/SalesOrder")}}>
                Sales Order
              </AntdMenu.Item>
            )}
          </AntdMenu.SubMenu>
        )}

        {can('is_qty_ctrl') && (
          <AntdMenu.SubMenu key="quality_control" title='QUALITY CONTROL'>
            {canAny('add_design_mix_master', 'view_design_mix_master', 'change_design_mix_master', 'delete_design_mix_master') && (
              <AntdMenu.Item key="design_mix" onClick={() =>{navigate("/DesignMix")}}>Design Mix</AntdMenu.Item>
            )}
            {canAny('add_moisture_correction_master', 'view_moisture_correction_master', 'change_moisture_correction_master', 'delete_moisture_correction_master') && (
              <AntdMenu.Item key="moisture_correction"  onClick={() =>{navigate("/MoistureCorrection")}}>
                Moisture Correction
              </AntdMenu.Item>
            )}
            {canAny('add_compressive_strength_master', 'change_compressive_strength_master', 'delete_compressive_strength_master', 'view_compressive_strength_master') && (
             <AntdMenu.Item key="cube_test_report" onClick={() =>{navigate("/CubeTestReport")}}>
                Cube Test Report
              </AntdMenu.Item>
            )}
            {canAny('view_del_challan_master') && (
              <AntdMenu.Item key="qc_delivery_challan_report" onClick={() => { navigate('/QcDeliveryChallanReport'); }}>
                Delivery Challan Report
              </AntdMenu.Item>
            )} 
          </AntdMenu.SubMenu>
        )}

        {can('is_planning') && (
          <AntdMenu.SubMenu key="planning" title='PLANNING'>
            {canAny('add_work_schedule_master', 'view_work_schedule_master', 'change_work_schedule_master', 'delete_work_schedule_master') && (
              <AntdMenu.Item key="work_schedule" onClick={() =>{navigate("/WorkSchedule")}}>
                Work Schedule
              </AntdMenu.Item>
            )}
          </AntdMenu.SubMenu>
        )}

        {can('is_purchase') && (
          <AntdMenu.SubMenu key="purchase" title='PURCHASE'>
            {canAny('add_entity_vendor_detail', 'view_entity_vendor_detail', 'change_entity_vendor_detail', 'delete_entity_vendor_detail') && (
              <AntdMenu.Item key="vendor" onClick={() =>{navigate("/Vendor")}}>
                  Vendor
              </AntdMenu.Item>
            )}
            <AntdMenu.Item key="purchase_order" onClick={() =>{navigate("/PurchaseOrder")}}>
                Purchase Order
            </AntdMenu.Item>
            {canAny('add_purchase_invoice', 'view_purchase_invoice', 'edit_purchase_invoice', 'delete_purchase_invoice') && (
                <AntdMenu.Item key="purchase_invoice" onClick={() =>{navigate("/PurchaseInvoice")}}>
                Purchase Invoice
                </AntdMenu.Item>
            )}
          </AntdMenu.SubMenu>
        )}

        {can('is_dispatch') && (
          <AntdMenu.SubMenu key="dispatch" title='DISPATCH'>
            {canAny('add_pump_clearance', 'view_pump_clearance', 'edit_pump_clearance', 'delete_pump_clearance') && (
              <AntdMenu.Item key="pump_clearance" onClick={() =>{navigate("/PumpClearance")}}>
                  Pump Clearance
              </AntdMenu.Item>
            )}
            {canAny('add_del_challan_master', 'view_del_challan_master', 'change_del_challan_master', 'delete_del_challan_master') && (
              <AntdMenu.Item key="delivery_challan" onClick={() =>{navigate("/DeliveryChallan")}}>
                DeliveryChallan
              </AntdMenu.Item>
            )}
          </AntdMenu.SubMenu>
        )}

        {can('is_gate') && (
          <AntdMenu.SubMenu key="gate" title='GATE'>
            {canAny('add_gate_pass_master', 'view_gate_pass_master', 'change_gate_pass_master', 'delete_gate_pass_master') && (
              <>
             {/* <AntdMenu.Item key="check_out" onClick={() =>{navigate("/CheckOut")}}>
                  Check Out
              </AntdMenu.Item>*/}
              <AntdMenu.Item key="check_in"  onClick={() =>{navigate("/CheckIn")}}>
                  Check In
              </AntdMenu.Item>
              <AntdMenu.Item key="check_in_km_correction" onClick={() =>{navigate("/CheckInKmCorrection")}}>
                  Check-In KM Correction
              </AntdMenu.Item>
              <AntdMenu.Item key="gate_pass" onClick={() =>{navigate("/VehicleGatePass")}}>
                  Vehicle Gate Pass
              </AntdMenu.Item>
              </>
            )}
          </AntdMenu.SubMenu> 
        )}     

      {can('is_accounts') && (
        <AntdMenu.SubMenu key="accounts" title='ACCOUNTS'>
          {canAny('add_grouping', 'view_grouping', 'edit_grouping', 'delete_grouping') && (
            <AntdMenu.Item key="group_form" onClick={() =>{navigate("/GroupForm")}}>
              Group Form
            </AntdMenu.Item>
          )}
          {canAny('add_entity_bank_detail', 'view_entity_bank_detail', 'change_entity_bank_detail', 'delete_entity_bank_detail') && (
              <AntdMenu.Item key="bank" onClick={() =>{navigate("/Bank")}}>
              Bank
            </AntdMenu.Item>
          )}
          {canAny('add_invoice_master', 'view_invoice_master', 'change_invoice_master', 'delete_invoice_master') && (
              <>
              <AntdMenu.Item key="sales_invoice" onClick={() =>{navigate("/SalesInvoice")}}>
                Sales Invoice
              </AntdMenu.Item>
              <AntdMenu.Item key="direct_invoice" onClick={() =>{navigate("/DirectInvoice")}}>
                Direct Invoice
              </AntdMenu.Item>
              </>
          )}
          <AntdMenu.Item key="credit_note" onClick={() =>{navigate("/CreditNote")}}>
            Credit Note
          </AntdMenu.Item>
          <AntdMenu.Item key="debit_note" onClick={() =>{navigate("/DebitNote")}}>
            Debit Note
          </AntdMenu.Item>
          <AntdMenu.Item key="general_journal" onClick={() =>{navigate("/GeneralJournal")}}>
            General Journal
          </AntdMenu.Item>
        </AntdMenu.SubMenu>
      )}     

      {can('is_transport') && (
        <AntdMenu.SubMenu key="transport" title='TRANSPORT'>
          {canAny('add_equipment_master', 'view_equipment_master', 'change_equipment_master', 'delete_equipment_master') && (
            <AntdMenu.Item key="equipment" onClick={() =>{navigate("/Equipment")}}>
              Equipment
            </AntdMenu.Item>
          )}
        </AntdMenu.SubMenu>
      )}

      {can('is_store') && (
          <AntdMenu.SubMenu key="store" title='STORE'>
            {canAny('add_gmr_master', 'view_gmr_master', 'change_gmr_master', 'delete_gmr_master') && (
              <AntdMenu.Item key="grn" onClick={() =>{navigate("/GoodsReceiptNote")}}>
                Goods Receipt Note
              </AntdMenu.Item>
            )}
            {canAny('add_purchase_invoice', 'view_purchase_invoice', 'edit_purchase_invoice', 'delete_purchase_invoice') && (
              <AntdMenu.Item key="store_purchase_invoice" onClick={() =>{navigate("/PurchaseInvoice")}}>
                Purchase Invoice
              </AntdMenu.Item>
            )}
            {canAny('add_consumption_master', 'view_consumption_master', 'change_consumption_master', 'delete_consumption_master') && (
              <AntdMenu.Item key="consumption" onClick={() =>{navigate("/ConsumptionNote")}}>
                Consumption Note
              </AntdMenu.Item>
            )}
            {canAny('add_consumption_master', 'view_consumption_master', 'change_consumption_master', 'delete_consumption_master') && (
              <AntdMenu.Item key="diesel-consumption" onClick={() =>{navigate("/DieselConsumption")}}>
                Diesel Consumption
              </AntdMenu.Item>
            )}
            {canAny('view_store_reports', 'view_consumption_master') && (
              <AntdMenu.Item key="diesel-stock-statement" onClick={() =>{navigate("/DieselStockConsumptionStatement")}}>
                Diesel Stock Statement
              </AntdMenu.Item>
            )}
          </AntdMenu.SubMenu>
      )}

      {(can('is_utility') || canAny('add_concrete_estimator_master', 'view_concrete_estimator_master', 'change_concrete_estimator_master', 'delete_concrete_estimator_master')) && (
        <AntdMenu.SubMenu key="utility" title='UTILITY'>
          {canAny('add_concrete_estimator_master', 'view_concrete_estimator_master', 'change_concrete_estimator_master', 'delete_concrete_estimator_master') && (
            <AntdMenu.Item key="concrete_estimator" onClick={() => { navigate('/ConcreteEstimator'); }}>
              Concrete Estimator
            </AntdMenu.Item>
          )}
        </AntdMenu.SubMenu>
      )}

      {can('is_maintenance') && (
        <AntdMenu.SubMenu key="maintenance" title='MAINTENANCE'>
          {canAny('add_maintenance_daily_master', 'view_maintenance_daily_master', 'change_maintenance_daily_master', 'delete_maintenance_daily_master') && (
            <AntdMenu.Item key="daily_plant_log" onClick={() => { navigate('/DailyPlantLog'); }}>
              Daily Plant Log
            </AntdMenu.Item>
          )}
          {canAny('view_maintenance_daily_master') && (
            <AntdMenu.Item key="maintenance_report" onClick={() => { navigate('/MaintenanceReport'); }}>
              Maintenance Report
            </AntdMenu.Item>
          )}
          {canAny('add_maintenance_service_master', 'view_maintenance_service_master', 'change_maintenance_service_master', 'delete_maintenance_service_master') && (
            <AntdMenu.Item key="preventive_maintenance" onClick={() => { navigate('/PreventiveMaintenance'); }}>
              Service & Breakdown
            </AntdMenu.Item>
          )}
          {canAny('add_maintenance_monthly_cost', 'view_maintenance_monthly_cost', 'change_maintenance_monthly_cost', 'delete_maintenance_monthly_cost') && (
            <AntdMenu.Item key="maintenance_monthly_cost" onClick={() => { navigate('/MaintenanceMonthlyCost'); }}>
              Month-End Costs
            </AntdMenu.Item>
          )}
        </AntdMenu.SubMenu>
      )} 

      {canAny('view_accounts_reports', 'view_transport_reports', 'view_marketting_reports', 'view_dispatch_reports', 'view_store_reports') && (
        <AntdMenu.Item key="report" onClick={() =>{navigate("/ReportAll")}}>
          REPORTS
        </AntdMenu.Item> 
      )}   


    
    {/* {(isAdmin || (category['myCategory'][0].is_consumptionnote  === true)) && (
    <Dropdown>
        <Dropdown.Toggle className="dropdown-custom-1">
          CONSUMPTION NOTE
          <span style={{color:"#1a1e21"}}></span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {(isAdmin || (category?.myCategory?.[0]?.Is_consumptionnote_add === true) || (category?.myCategory?.[0]?.Is_consumptionnote_view === true)|| (category?.myCategory?.[0]?.Is_consumptionnote_edit === true) || (category?.myCategory?.[0]?.Is_consumptionnote_delete === true)) &&(
              <Dropdown.Item onClick={() =>{navigate("/ConsumptionNote")}}>
                     Consumption Note
              </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>  
    )}  */}
        
      </AntdMenu>
    </Menu>
  );
} 
